import { colors } from "@indeed/ifl-tokens";
import React from "react";
import { StyleSheet } from "react-native";

import { Box, Button, Flex, Language, Text } from "../../../../../../../../mads";
import { useI18n } from "../../../../../../../../shared/I18n";
import ViewJobLabelledContent from "../../common/ViewJobLabelledContent/ViewJobLabelledContent";

export interface DateTimeSectionProps {
  dateTimes: string[];
  timezone: string;
}

export const MultiDateTimeContent: React.FC<Pick<DateTimeSectionProps, "dateTimes">> = ({
  dateTimes,
}) => {
  const gt = useI18n();
  const [showAllDateTimes, setShowAllDateTimes] = React.useState(false);

  return (
    <>
      <Box id="dateTimes" sx={styles.dateTimesContainer}>
        {dateTimes.slice(0, showAllDateTimes ? dateTimes.length : 1).map((dateTime) => (
          <Box key={dateTime}>
            <Text level={3}>{dateTime}</Text>
          </Box>
        ))}
      </Box>
      <Box sx={styles.showMoreButtonContainer}>
        <Button
          onPress={() => setShowAllDateTimes(!showAllDateTimes)}
          variant="text"
          sx={styles.showMoreButton}
        >
          <Text sx={styles.showMoreButtonText}>
            {showAllDateTimes
              ? gt.pgettext(
                  "View job overview - Show fewer date times link",
                  "Show fewer dates and times",
                )
              : gt.pgettext(
                  "View job overview - Show more date times link",
                  "Show more dates and times",
                )}
          </Text>
        </Button>
      </Box>
    </>
  );
};

export const DateTimeSection: React.FC<DateTimeSectionProps> = ({ dateTimes, timezone }) => {
  const gt = useI18n();

  return dateTimes.length ? (
    <ViewJobLabelledContent
      label={gt.npgettext(
        "View job overview - event dates and times",
        "Date and time",
        "Dates and times",
        dateTimes.length,
      )}
    >
      {!!timezone.length && (
        <Flex sx={styles.timezoneContainer}>
          <Box sx={styles.timezoneIconContainer}>
            <Language color={colors.neutral[700]} size="xxs" aria-hidden={true} />
          </Box>
          <Text variant="secondary" level={2} sx={styles.timezoneText}>
            {timezone}
          </Text>
        </Flex>
      )}
      {dateTimes.length > 1 ? (
        <MultiDateTimeContent dateTimes={dateTimes} />
      ) : (
        <Box key={dateTimes[0]} sx={styles.dateTimesContainer}>
          <Text level={3}>{dateTimes[0]}</Text>
        </Box>
      )}
    </ViewJobLabelledContent>
  ) : null;
};

const styles = StyleSheet.create({
  timezoneContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 8,
  },
  timezoneIconContainer: {
    paddingRight: 4,
    top: 2,
  },
  timezoneText: {
    fontStyle: "italic",
  },
  dateTimesContainer: {
    marginBottom: 2,
  },
  showMoreButtonContainer: {
    alignSelf: "flex-start",
  },
  showMoreButton: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  showMoreButtonText: {
    fontWeight: "bold",
    color: colors.primary[800],
    fontSize: 14,
  },
});
